import { createFileRoute } from '@tanstack/react-router';
import { Shield } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/roles')({
  component: RolesPage,
});

function RolesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-primary">Roles & Permissions</h1>
        <p className="text-muted-foreground">
          Configure roles and their associated permissions
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5" />
            Role Management
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Role management features coming soon. For now, manage roles from the Users page.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
